import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareUndoIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper width='16' height='17' {...props}>
    <path
      d='M16 9.535a6.507 6.507 0 00-6.5-6.5H5V0L1.465 3.535 5 7.071V4.035h4.5A5.5 5.5 0 119 15.013v1a6.507 6.507 0 007-6.478z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M16 9.535a6.507 6.507 0 00-6.5-6.5H4V0L.465 3.535 4 7.071V4.035h5.5A5.5 5.5 0 119 15.013v1a6.507 6.507 0 007-6.478z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const UndoIcon = memo(BareUndoIcon);
